import { storeEvent }      from "_analytics/index";
import { shortenNumber }   from "_common/utils";
import { SecondaryButton } from "_components/atoms/button";
import Icon                from "_components/atoms/icon";
import Image               from "_components/atoms/image";
import Typography          from "_components/atoms/typography";
import FollowUser          from "_components/molecules/followUser";

import useStyles from "./styles";

const component = ( { data, handleGAEvent } ) => {
	const { classes } = useStyles ( { isLive: data.isLive } );

	const href = data.isLive ? `/profile/${ data.id }?play_recent=${ true }` : `/profile/${ data.id }`;

	return (
		<div className = { classes.contianer }>

			<div className = { classes.imageContainer }>
				<a
					href    = { href }
					onClick = { () => {
						if ( data.isLive )
							return;
						storeEvent ( "Profile", "View", data.id );
					} }
					rel     = "noreferrer"
					target  = "_blank"
				>
					<Image
						className   = { classes.image }
						placeholder = "/images/circle-placeholder.webp"
						src         = { data.photo }
						type        = { "hdpi" }

					/>
				</a>

				<a
					href   = { href }
					rel    = "noreferrer"
					target = "_blank"
				>
					{data.isLive ? (
						<div className = { classes.liveTag }>
							<span className = { classes.liveTagText }>LIVE</span>
						</div>
					) : null}
				</a>
			</div>

			<div className = { classes.infoContainer }>
				<div className = { classes.nameContianer }>
					<a
						className = { classes.nameLink }
						href      = { `/profile/${ data.id }` }
						onClick   = { () => storeEvent ( "Profile", "View", data.id ) }
						rel       = "noreferrer"
						target    = "_blank"
					>
						<Typography
							className = { classes.name }
							title     = { data.name }
						/>
					</a>

					{data.isCeleb ? (
						<Icon
							sameInBothTheme
							className = { classes.icon }
							name      = "verify"
						/>
					) : null}
				</div>

				<Typography
					className = { classes.followerCount }
					color     = "secondary"
					title     = { `${ shortenNumber ( data.followers ) } Followers` }
				/>

			</div>

			<FollowUser
				followComponent   = { (
					<SecondaryButton
						fullWidth
						noBorder
						buttonTextClassName = { classes.followButtonText }
						className           = { classes.followButton }
						title               = { "+ Follow" }
					/>
				) }
				fromHomePage      = { true }
				handleGAEvent     = { handleGAEvent }
				isFollowing       = { data.isFollowing }
				unfollowComponent = { (
					<SecondaryButton
						fullWidth
						noBorder
						className = { classes.unFollowButton }
						title     = { "Following" }
					/>
				) }
				userId            = { data.id }
				userName          = { data.name }
			/>

		</div>
	);

};

export default component;
